<div *ngIf="petService.pet_teeth.dog">
    <svg
                version="1.1"
                id="svg1"
                width="400"
                height="933"
                viewBox="0 0 400 933"
                sodipodi:docname="DogAdultTeeth2.svg"
                inkscape:version="1.4.2 (ebf0e940, 2025-05-08)"
                xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
                xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:svg="http://www.w3.org/2000/svg"
                onclick="document.getElementById('tableToothProblem').scrollIntoView({ behavior: 'smooth' });"
                class="responsive-svg">
                <defs
                    id="defs1" /> 
                <g
                    inkscape:groupmode="layer"
                    inkscape:label="Image"
                    id="g1">
                    <image
                    width="400"
                    height="933"
                    preserveAspectRatio="none"
                    id="image1"
                    xlink:href="assets/images/dog-teeth.png"
                    style="display:inline" />
                    <ellipse
                    style="display:inline;fill:#000000;fill-opacity:0"
                    id="path2"
                    cx="167.18716"
                    cy="52.780163"
                    rx="10.046224"
                    ry="10.196168"
                    inkscape:label="102"
                    class="tooth-area"
                    (click)="toothClicked(102)"
                    [class.selected]="isToothSelected(102)" 
                    [class.active]="isToothInProblem(102)"/>
                    <ellipse
                    style="display:inline;fill:#000000;fill-opacity:0"
                    id="path2-2"
                    cx="234.75578"
                    cy="53.225239"
                    rx="10.046224"
                    ry="10.196168"
                    inkscape:label="202"
                    class="tooth-area"
                    (click)="toothClicked(202)"
                    [class.selected]="isToothSelected(202)" 
                    [class.active]="isToothInProblem(202)"/>
                    <ellipse
                    style="fill:#000000;fill-opacity:0"
                    id="path3"
                    ry="9.502182"
                    rx="8.7245979"
                    cy="42.230034"
                    cx="189.76065"
                    inkscape:label="101"
                    class="tooth-area"
                    (click)="toothClicked(101)"
                    [class.selected]="isToothSelected(101)" 
                    [class.active]="isToothInProblem(101)"/>
                    <ellipse
                    style="fill:#000000;fill-opacity:0"
                    id="path3-8"
                    ry="9.502182"
                    rx="8.7245979"
                    cy="41.966084"
                    cx="212.55057"
                    inkscape:label="201"
                    class="tooth-area"
                    (click)="toothClicked(201)"
                    [class.selected]="isToothSelected(201)" 
                    [class.active]="isToothInProblem(201)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 152.57841,64.926985 3.71012,2.782585 1.62317,5.56517 2.31882,4.869524 0.46377,3.941996 -1.15941,3.246349 -3.47823,3.478231 -6.26082,0.463764 -3.01447,-0.695646 -2.5507,-3.478231 -0.92753,-1.623175 -3.24635,1.159411 -6.26081,0.463764 -2.55071,-1.855057 1.15941,-3.941995 3.47823,-5.101406 3.942,-3.941996 3.47823,-3.246349 3.01447,-1.623175 2.5507,-0.927528 z"
                    id="path4"
                    inkscape:label="103" 
                    class="tooth-area"
                    (click)="toothClicked(103)"
                    [class.selected]="isToothSelected(103)"
                    [class.active]="isToothInProblem(103)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 244.40372,69.100863 -1.85505,6.492698 -0.69565,4.869524 1.15941,4.869524 2.08694,2.318821 5.79705,1.391292 3.24635,-0.463764 2.5507,-2.318821 1.62318,-2.318821 2.31882,-0.231882 3.47823,1.391293 3.71011,-0.231882 2.08694,-1.855057 -1.39129,-3.478231 -3.01447,-4.40576 -2.78258,-3.941996 -3.01447,-2.782585 -3.24635,-1.623174 -4.40576,-2.086939 h -3.24635 l -2.5507,1.855057 z"
                    id="path5"
                    inkscape:label="203"
                    class="tooth-area"
                    (click)="toothClicked(203)"
                    [class.selected]="isToothSelected(203)" 
                    [class.active]="isToothInProblem(203)"/>
                    <path
                    style="fill:#000000;opacity:1;fill-opacity:0"
                    d="m 137.96984,119.18739 5.10141,6.02894 1.85506,4.63764 v 7.18834 l -1.15941,4.86953 -2.55071,7.42023 -3.94199,6.02893 -3.47823,2.31882 -3.01447,-0.92753 -3.24635,0.92753 -3.24635,3.71011 -3.71011,3.942 -4.17388,5.10141 -3.47823,2.08693 -3.71012,0.46377 -2.31882,-1.62318 -1.85505,-3.01446 v -4.17388 l 1.39129,-6.95646 2.08694,-7.88399 1.85505,-7.65211 4.63765,-9.97093 5.33328,-9.27529 3.942,-3.71011 3.71011,-1.62317 5.33329,-0.23189 z"
                    id="path6"
                    inkscape:label="104" 
                    class="tooth-area"
                    (click)="toothClicked(104)"
                    [class.selected]="isToothSelected(104)"
                    [class.active]="isToothInProblem(104)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 272.46146,116.17293 -7.884,2.5507 -4.86952,4.63764 -2.31882,4.17388 -0.46376,6.95646 1.15941,7.88399 3.01446,6.95647 2.31882,3.94199 2.78259,3.71011 3.94199,0.46377 3.942,0.46376 4.63764,4.86953 6.26082,6.4927 4.86952,3.47823 h 2.31882 l 2.78259,-1.62318 2.31882,-4.17388 -1.15941,-6.49269 -1.85506,-11.59411 -4.17388,-10.20281 -3.71011,-9.50717 -6.26082,-8.81152 -3.71011,-2.78258 z"
                    id="path7"
                    inkscape:label="204"
                    class="tooth-area"
                    (click)="toothClicked(204)"
                    [class.selected]="isToothSelected(204)" 
                    [class.active]="isToothInProblem(204)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 124.2888,206.37506 -9.0434,13.44916 -1.62318,5.79705 1.15941,9.27529 1.3913,3.47823 0.69564,6.4927 2.78259,1.85505 7.65211,0.23189 3.01446,-4.17388 2.78259,-7.42023 3.71011,-8.81152 -0.92753,-4.63764 3.01447,-4.63764 v -11.59411 l -3.47823,-3.71011 -7.88399,-0.46376 z"
                    id="path8"
                    inkscape:label="106"
                    class="tooth-area"
                    (click)="toothClicked(106)"
                    [class.selected]="isToothSelected(106)" 
                    [class.active]="isToothInProblem(106)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 268.98322,201.04177 6.26082,1.15941 2.31882,3.942 3.942,6.02893 5.79705,7.65211 1.39129,7.42023 -1.39129,8.57963 -1.85506,4.63765 v 4.40576 l -3.47823,2.08694 h -6.72458 l -2.78258,-3.24635 -5.79706,-14.14481 -0.69564,-7.18835 -2.08694,-3.24635 -0.46377,-7.6521 -1.15941,-3.71012 2.55071,-4.63764 z"
                    id="path9"
                    inkscape:label="206"
                    class="tooth-area"
                    (click)="toothClicked(206)"
                    [class.selected]="isToothSelected(206)" 
                    [class.active]="isToothInProblem(206)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 111.76717,253.21524 4.40576,2.31882 2.78258,4.40576 0.46377,5.10141 -1.85506,8.11587 -3.71011,4.40576 v 5.79705 l -9.50717,18.08681 -6.72458,0.46376 -4.869524,-2.78258 -0.695647,-7.42023 -0.463764,-14.60857 1.391293,-4.17388 11.594102,-13.44916 2.08694,-4.86953 z"
                    id="path10"
                    inkscape:label="107"
                    class="tooth-area"
                    (click)="toothClicked(107)"
                    [class.selected]="isToothSelected(107)" 
                    [class.active]="isToothInProblem(107)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 287.07003,252.98336 -3.24635,5.33329 0.69564,13.68104 2.78259,3.47823 v 6.02894 l 8.34775,19.01433 3.71012,1.62317 6.95646,-1.39129 1.39129,-2.08694 0.23188,-7.65211 1.3913,-0.46376 v -15.5361 l -11.59411,-16.92739 -0.92753,-3.24635 -2.78258,-1.3913 z"
                    id="path11"
                    inkscape:label="207"
                    class="tooth-area"
                    (click)="toothClicked(207)"
                    [class.selected]="isToothSelected(207)" 
                    [class.active]="isToothInProblem(207)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 88.115194,313.96835 -6.260816,9.73905 -7.883991,20.6375 -0.927529,8.34776 -1.391292,11.13034 0.231882,8.11587 2.782585,5.56517 6.72458,3.942 3.24635,-0.46377 5.56517,-4.17387 5.56517,-16.46363 1.15941,-14.37669 1.391293,-11.36223 6.492694,-9.97092 3.24635,-8.11588 -1.85505,-1.85505 -5.79706,-0.23189 -1.855052,0.92753 -3.710113,-2.08694 z"
                    id="path12"
                    inkscape:label="108"
                    class="tooth-area"
                    (click)="toothClicked(108)"
                    [class.selected]="isToothSelected(108)" 
                    [class.active]="isToothInProblem(108)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 302.83801,315.82341 -6.26082,-1.62318 -3.24635,3.24635 2.31882,7.42023 6.26082,9.27528 2.31882,7.18835 v 15.76798 l 3.71011,13.44916 5.56517,8.11587 7.65211,2.31882 6.26082,-3.94199 2.5507,-12.75352 -1.39129,-16.69551 -3.71011,-12.75351 -7.42023,-15.07234 -5.33329,-6.02893 -5.79705,-0.23189 z"
                    id="path13"
                    inkscape:label="208"
                    class="tooth-area"
                    (click)="toothClicked(208)"
                    [class.selected]="isToothSelected(208)" 
                    [class.active]="isToothInProblem(208)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 74.897915,388.17062 -2.782585,5.1014 0.695646,4.17388 3.710114,3.71011 3.478231,1.85506 -3.478231,3.47823 -1.623175,3.71012 2.086939,6.72458 4.637641,3.24635 5.333289,1.85505 8.579637,-3.24635 4.637639,-2.78258 7.88399,1.15941 7.18835,0.69565 3.47823,-5.33329 -1.39129,-8.81152 -3.942,-7.65211 -5.1014,-4.17388 -6.4927,-4.40576 -9.970933,-1.39129 -12.057868,0.23188 z"
                    id="path14"
                    inkscape:label="109"
                    class="tooth-area"
                    (click)="toothClicked(109)"
                    [class.selected]="isToothSelected(109)" 
                    [class.active]="isToothInProblem(109)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 299.01986,388.27599 -8.28637,6.39235 -5.68209,8.75988 -1.89403,6.1556 0.94701,4.02481 3.78806,3.55131 5.20858,0.94701 5.20858,-1.65727 5.20858,0.94701 7.81287,3.0778 9.2334,0.71026 5.20858,-5.20858 0.94701,-6.1556 -3.78806,-6.6291 6.1556,-5.20858 0.71026,-6.6291 -3.55131,-3.78806 -4.97182,-1.18377 -13.96847,0.23675 z"
                    id="path15"
                    inkscape:label="209"
                    class="tooth-area"
                    (click)="toothClicked(209)"
                    [class.selected]="isToothSelected(209)" 
                    [class.active]="isToothInProblem(209)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 300.44039,426.86684 -5.44534,4.97182 -3.31455,4.73508 -0.94701,5.20858 1.65727,2.60429 3.78806,2.36753 5.68209,-1.18377 4.02481,1.65728 10.41716,0.23675 3.31455,-1.89403 0.47351,-5.44533 -2.36754,-3.31455 2.84105,-3.31455 0.94701,-4.02481 -2.13078,-3.55131 h -8.28638 z"
                    id="path16"
                    inkscape:label="210"
                    class="tooth-area"
                    (click)="toothClicked(210)"
                    [class.selected]="isToothSelected(210)"
                    [class.active]="isToothInProblem(210)" />
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 101.80407,426.86684 6.6291,6.15559 2.84105,5.68209 0.23675,3.0778 -2.60429,4.73507 h -4.49832 l -5.682087,-0.71026 -4.024812,2.60429 -9.7069,-0.71026 -2.367536,-2.60429 -0.947015,-2.84105 2.841044,-5.20858 -3.788058,-4.26156 -0.236754,-3.55131 2.60429,-2.84104 z"
                    id="path17"
                    inkscape:label="110"
                    class="tooth-area"
                    (click)="toothClicked(110)"
                    [class.selected]="isToothSelected(110)" 
                    [class.active]="isToothInProblem(110)"/>
                    <ellipse
                    style="fill:#000000;fill-opacity:0"
                    id="path18"
                    cx="134.03932"
                    cy="183.173"
                    rx="7.6782308"
                    ry="9.934474"
                    inkscape:label="105" 
                    class="tooth-area"
                    (click)="toothClicked(105)"
                    [class.selected]="isToothSelected(105)"
                    [class.active]="isToothInProblem(105)"/>
                    <ellipse
                    style="display:inline;fill:#000000;fill-opacity:0"
                    id="path18-3"
                    cx="267.8912"
                    cy="182.99522"
                    rx="7.6782308"
                    ry="9.934474"
                    inkscape:label="205"
                    class="tooth-area"
                    (click)="toothClicked(205)"
                    [class.selected]="isToothSelected(205)" 
                    [class.active]="isToothInProblem(205)"/>
                    <ellipse
                    style="fill:#000000;fill-opacity:0"
                    id="path19"
                    cx="90.019608"
                    cy="487.62354"
                    rx="9.5632839"
                    ry="8.8356428"
                    inkscape:label="411"
                    class="tooth-area"
                    (click)="toothClicked(411)"
                    [class.selected]="isToothSelected(411)" 
                    [class.active]="isToothInProblem(411)"/>
                    <ellipse
                    style="fill:#000000;fill-opacity:0"
                    id="path19-1"
                    cx="312.44913"
                    cy="487.88452"
                    rx="9.5632839"
                    ry="8.8356428"
                    inkscape:label="311"
                    class="tooth-area"
                    (click)="toothClicked(311)"
                    [class.selected]="isToothSelected(311)" 
                    [class.active]="isToothInProblem(311)"/>
                    <ellipse
                    style="fill:#000000;fill-opacity:0"
                    id="path20"
                    cx="211.57022"
                    cy="880.94629"
                    rx="7.7719674"
                    ry="8.2654257"
                    inkscape:label="301"
                    class="tooth-area"
                    (click)="toothClicked(301)"
                    [class.selected]="isToothSelected(301)" 
                    [class.active]="isToothInProblem(301)"/>
                    <ellipse
                    style="fill:#000000;fill-opacity:0"
                    id="path20-8"
                    cx="190.78691"
                    cy="881.74579"
                    rx="7.7719674"
                    ry="8.2654257"
                    inkscape:label="401"
                    class="tooth-area"
                    (click)="toothClicked(401)"
                    [class.selected]="isToothSelected(401)" 
                    [class.active]="isToothInProblem(401)"/>
                    <ellipse
                    style="fill:#000000;fill-opacity:0"
                    id="path20-8-6"
                    cx="232.22246"
                    cy="870.90283"
                    rx="9.7458"
                    ry="8.2654257"
                    inkscape:label="302"
                    class="tooth-area"
                    (click)="toothClicked(302)"
                    [class.selected]="isToothSelected(302)" 
                    [class.active]="isToothInProblem(302)"/>
                    <ellipse
                    style="fill:#000000;fill-opacity:0"
                    id="path20-8-6-8"
                    cx="169.32333"
                    cy="871.00562"
                    rx="9.7458"
                    ry="8.2654257"
                    inkscape:label="402"
                    class="tooth-area"
                    (click)="toothClicked(402)"
                    [class.selected]="isToothSelected(402)" 
                    [class.active]="isToothInProblem(402)"/>
                    <ellipse
                    style="fill:#000000;fill-opacity:0"
                    id="path20-8-6-8-5"
                    cx="253.14024"
                    cy="851.26733"
                    rx="8.5121546"
                    ry="8.2654257"
                    inkscape:label="303"
                    class="tooth-area"
                    (click)="toothClicked(303)"
                    [class.selected]="isToothSelected(303)" 
                    [class.active]="isToothInProblem(303)"/>
                    <ellipse
                    style="display:inline;fill:#000000;fill-opacity:0"
                    id="path20-8-6-8-5-6"
                    cx="150.85974"
                    cy="851.01874"
                    rx="8.5121546"
                    ry="8.2654257"
                    inkscape:label="403"
                    class="tooth-area"
                    (click)="toothClicked(403)"
                    [class.selected]="isToothSelected(403)" 
                    [class.active]="isToothInProblem(403)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 97.802083,503.06821 -4.819815,-0.40165 -4.016513,3.21321 -0.401651,21.28752 4.217338,5.22146 9.237978,1.60661 8.83633,-3.81569 3.01238,-7.43055 -0.40165,-11.04541 -4.01651,-8.6355 -2.81156,-1.40578 -5.02064,-0.40165 z"
                    id="path21"
                    inkscape:label="410"
                    class="tooth-area"
                    (click)="toothClicked(410)"
                    [class.selected]="isToothSelected(410)" 
                    [class.active]="isToothInProblem(410)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 304.65248,503.26904 -3.01238,-1.60661 -5.22147,-0.20083 -4.61899,5.02065 -1.20495,3.01238 -0.8033,14.66027 1.6066,3.41404 4.21734,3.81568 6.2256,2.61074 6.22559,-0.60248 4.81982,-4.41816 2.00825,-3.81569 0.40165,-18.47596 -2.61073,-3.01238 -2.61073,-1.60661 z"
                    id="path22"
                    inkscape:label="310"
                    class="tooth-area"
                    (click)="toothClicked(310)"
                    [class.selected]="isToothSelected(310)" 
                    [class.active]="isToothInProblem(310)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 90.912678,549.78944 v 8.29496 l 1.658991,10.94933 4.313375,13.27193 4.976976,12.27653 7.29955,8.62675 4.97697,2.65438 5.97237,0.3318 4.64517,-3.64978 1.65899,-6.96776 -1.32719,-3.98158 0.3318,-5.97236 -2.98618,-13.93552 -5.64057,-16.25811 v -9.62214 l -3.98158,-6.30417 -3.64978,-0.66359 H 97.880438 l -4.645173,5.30877 z"
                    id="path23"
                    inkscape:label="409"
                    class="tooth-area"
                    (click)="toothClicked(409)"
                    [class.selected]="isToothSelected(409)" 
                    [class.active]="isToothInProblem(409)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 287.66895,539.17191 -4.31338,6.96776 0.3318,9.62214 -3.64978,11.61293 -3.64978,15.92631 -0.33179,8.29495 -1.3272,7.29956 3.31798,4.97697 6.30417,2.65439 8.62675,-3.64978 7.63135,-11.61293 8.29496,-22.56227 1.32719,-16.25811 -2.65439,-8.29495 -5.30876,-4.97697 z"
                    id="path24"
                    inkscape:label="309" 
                    class="tooth-area"
                    (click)="toothClicked(309)"
                    [class.selected]="isToothSelected(309)"
                    [class.active]="isToothInProblem(309)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 115.46574,613.16288 3.98157,-1.32719 4.64518,1.32719 2.98618,8.62675 3.31798,13.27193 -1.99079,9.29034 0.6636,16.58991 -4.64517,4.31337 h -6.96776 l -2.65439,-2.65438 -1.32719,-6.96776 -5.30877,-18.2489 3.64978,-15.59451 v -6.96776 z"
                    id="path25"
                    inkscape:label="408"
                    class="tooth-area"
                    (click)="toothClicked(408)"
                    [class.selected]="isToothSelected(408)" 
                    [class.active]="isToothInProblem(408)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 275.39242,616.48086 -2.32259,14.59912 0.3318,29.86183 5.30877,5.64056 4.31338,-0.66359 4.64517,-4.31338 0.3318,-5.97236 5.64056,-14.93092 -0.33179,-7.29956 -2.65439,-12.60832 -0.99539,-6.30417 -4.31338,-2.32258 -7.29956,0.99539 z"
                    id="path26"
                    inkscape:label="308" 
                    class="tooth-area"
                    (click)="toothClicked(308)"
                    [class.selected]="isToothSelected(308)"
                    [class.active]="isToothInProblem(308)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 128.07406,669.23676 2.65439,6.30416 3.64978,10.61754 -0.6636,24.22126 -3.31798,4.31338 h -7.63135 l -3.64978,-2.65439 v -2.98618 l -6.96776,-18.24889 0.66359,-4.64518 2.98619,-8.95855 -0.6636,-5.97236 3.98158,-2.65439 z"
                    id="path27"
                    inkscape:label="407" 
                    class="tooth-area"
                    (click)="toothClicked(407)"
                    [class.selected]="isToothSelected(407)"
                    [class.active]="isToothInProblem(407)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 274.06523,670.23215 -1.65899,6.30417 -2.65439,10.28574 v 5.97236 l 0.6636,17.25351 1.32719,3.31798 4.64517,1.99078 5.64057,-1.65899 1.65899,-5.30877 7.29956,-15.59451 v -5.97236 l -3.64978,-9.62215 0.3318,-5.30877 -3.31798,-3.64977 h -6.30417 z"
                    id="path28"
                    inkscape:label="307" 
                    class="tooth-area"
                    (click)="toothClicked(307)"
                    [class.selected]="isToothSelected(307)"
                    [class.active]="isToothInProblem(307)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 120.44271,720.66546 -4.31338,5.64057 0.3318,11.61294 2.65439,5.97236 1.99078,4.97697 3.98158,2.32259 7.63136,-0.9954 1.32719,-6.96776 -0.3318,-7.96315 1.65899,-2.65438 -0.99539,-9.95395 -0.9954,-3.98157 -8.62675,-1.65899 z"
                    id="path29"
                    inkscape:label="406"
                    class="tooth-area"
                    (click)="toothClicked(406)"
                    [class.selected]="isToothSelected(406)" 
                    [class.active]="isToothInProblem(406)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 268.75646,720.33367 -1.32719,12.27653 1.65899,2.65438 -0.6636,6.63596 1.99079,3.98158 -0.6636,2.32259 3.64978,2.65438 8.62675,-1.32719 0.9954,-5.97237 2.98618,-5.64056 1.32719,-6.30417 -1.65899,-6.63596 -5.30877,-6.63596 -6.63596,-0.6636 z"
                    id="path30"
                    inkscape:label="306"
                    class="tooth-area"
                    (click)="toothClicked(306)"
                    [class.selected]="isToothSelected(306)" 
                    [class.active]="isToothInProblem(306)"/>
                    <path
                    style="display:inline;fill:#000000;fill-opacity:0"
                    d="m 114.13854,791.67026 10.94934,9.95394 7.63136,5.97237 5.64057,0.99539 3.98157,4.31337 4.64518,10.61754 0.99539,10.61754 -5.64057,5.97237 -6.30416,1.65899 -5.97237,-1.32719 -5.64056,-5.97237 -10.28575,-16.5899 -7.96315,-18.9125 v -6.30416 l 2.32259,-2.32259 z"
                    id="path31"
                    inkscape:label="404"
                    class="tooth-area"
                    (click)="toothClicked(404)"
                    [class.selected]="isToothSelected(404)" 
                    [class.active]="isToothInProblem(404)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 263.11589,807.92836 -6.63596,10.61754 -1.32719,5.97237 v 8.29495 l 3.98157,6.63596 4.97697,1.65899 6.30417,0.9954 7.29956,-5.64057 7.63135,-12.94013 8.95855,-19.90788 2.65439,-9.95394 -3.98158,-3.31799 -6.63596,2.65439 -9.29035,8.95855 -6.96776,4.31337 z"
                    id="path32"
                    inkscape:label="304" 
                    class="tooth-area"
                    (click)="toothClicked(304)"
                    [class.selected]="isToothSelected(304)"
                    [class.active]="isToothInProblem(304)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 275.72422,753.84527 -4.64518,6.63597 0.9954,9.29034 4.31337,3.98158 9.29035,-9.95394 -0.99539,-4.31338 z"
                    id="path33"
                    inkscape:label="305"
                    class="tooth-area"
                    (click)="toothClicked(305)"
                    [class.selected]="isToothSelected(305)" 
                    [class.active]="isToothInProblem(305)"/>
                    <path
                    style="fill:#000000;fill-opacity:0"
                    d="m 124.75608,752.18628 6.63597,7.63136 0.33179,8.62675 -5.30877,5.64057 -5.97236,-5.64057 -2.98618,-3.98158 -0.3318,-5.30877 z"
                    id="path34"
                    inkscape:label="405"
                    class="tooth-area"
                    (click)="toothClicked(405)"
                    [class.selected]="isToothSelected(405)" 
                    [class.active]="isToothInProblem(405)"/>
                </g>
   </svg>
</div> 
 

<div *ngIf="petService.pet_teeth.puppy">
      <svg
      version="1.1"
      id="svg1"
      width="400"
      height="822"
      viewBox="0 0 400 822"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:svg="http://www.w3.org/2000/svg"
      onclick="document.getElementById('tableToothProblem').scrollIntoView({ behavior: 'smooth' });"
      class="responsive-svg">
   <defs
      id="defs1" />
   <g
      id="g1">
      <image
         width="400"
         height="822"
         preserveAspectRatio="none"
         id="image2" xlink:href="assets/images/puppy-teeth.png" />
      <path
         style="fill:#000000;fill-opacity:0"
         d="m 136.48966,80.957103 5.68707,4.683468 4.0144,7.359737 -1.67267,9.701472 -1.33813,2.0072 -8.36334,4.68347 -3.0108,7.69427 -2.0072,8.0288 -0.66907,8.36334 -2.34173,4.68347 -3.67987,-1.33814 -3.67987,-8.0288 -1.67266,-12.71227 2.34173,-17.395743 4.0144,-10.036004 4.34894,-6.356136 z"
         id="504" class="tooth-area" (click)="toothClicked(504)" [class.selected]="isToothSelected(504)" [class.active]="isToothInProblem(504)" />
      <path
         style="fill:#000000;fill-opacity:0"
         d="m 248.89291,82.295237 -6.69067,10.036004 0.33453,9.701469 3.01081,5.018 4.68346,1.67267 5.35254,6.35614 2.34173,9.70147 1.00361,9.36694 1.67266,4.0144 3.67987,-1.0036 3.34534,-8.02881 1.33813,-10.036 v -11.70867 l -4.68347,-15.054009 -6.69067,-9.701471 z"
         id="604" class="tooth-area" (click)="toothClicked(604)" [class.selected]="isToothSelected(604)" [class.active]="isToothInProblem(604)"/>
      <path
         style="fill:#000000;fill-opacity:0"
         d="m 137.82779,149.20193 5.01801,5.68707 3.34533,12.71227 -1.0036,11.70868 v 9.70147 l -1.33813,5.35253 -3.34534,5.01801 -7.69427,0.33453 -3.67987,-3.34534 -0.33453,-6.0216 -3.0108,-14.0504 1.0036,-10.03601 5.68707,-12.37774 z"
         id="506" class="tooth-area" (click)="toothClicked(506)" [class.selected]="isToothSelected(506)" [class.active]="isToothInProblem(506)"/>
      <path
         style="fill:#000000;fill-opacity:0"
         d="m 246.21664,150.54007 6.35614,1.33813 8.69787,20.40654 -0.66907,10.37054 -3.34533,11.03961 0.33453,5.018 -6.35613,2.34173 -7.02521,-1.67266 -1.33813,-8.69788 -0.66907,-9.70147 -2.0072,-8.0288 1.33813,-12.37774 z"
         id="606" class="tooth-area" (click)="toothClicked(606)" [class.selected]="isToothSelected(606)" [class.active]="isToothInProblem(606)"/>
      <path
         style="fill:#000000;fill-opacity:0"
         d="m 250.90011,209.75249 -3.67987,11.03961 1.0036,12.71227 3.34534,16.05761 1.67267,4.0144 v 7.0252 l 3.0108,10.03601 4.0144,7.35973 5.35253,2.0072 4.34894,-1.0036 4.34894,-7.0252 v -13.0468 l -2.67627,-13.71588 -0.66907,-14.38494 -4.68347,-13.0468 -5.68707,-6.02161 -5.35253,-1.33813 z"
         id="607" class="tooth-area" (click)="toothClicked(607)" [class.selected]="isToothSelected(607)" [class.active]="isToothInProblem(607)"/>
      <path
         style="fill:#000000;fill-opacity:0"
         d="m 98.803964,293.20397 0.427723,9.19604 1.924753,3.20792 v 3.42178 l -4.704951,5.77426 -2.352475,5.34654 1.283168,5.13267 2.780198,2.56634 h 6.6297 l 5.77426,-2.99406 5.98812,-1.92475 7.48515,-0.64159 3.8495,-3.42178 0.64159,-6.20198 -1.06931,-6.84357 -3.20792,-4.70495 -4.49109,-2.56633 -2.56634,-4.06337 -5.56039,-5.98812 -7.27129,-0.64158 -3.8495,2.99406 z"
         id="508" class="tooth-area" (click)="toothClicked(203)" [class.selected]="isToothSelected(203)" [class.active]="isToothInProblem(203)"/>
      <path
         style="fill:#000000;fill-opacity:0"
         d="m 287.42971,304.32476 -2.13861,4.06337 0.64158,2.56634 3.63565,4.27723 3.20792,5.13267 -0.64159,5.34653 -4.70495,3.84951 h -5.56039 l -5.77426,-3.63564 -7.69901,-2.13862 -6.20198,-0.42772 -3.42178,-4.27723 -0.42773,-7.05743 3.63565,-8.34059 5.13267,-3.20792 3.20792,-5.34654 5.34654,-5.13267 5.34653,-1.28317 4.91881,3.42178 2.35248,5.34654 z"
         id="608" class="tooth-area" (click)="toothClicked(608)" [class.selected]="isToothSelected(608)" [class.active]="isToothInProblem(608)"/>
      <path
         style="fill:#000000;fill-opacity:0"
         d="m 136.01664,58.131593 -1.55206,5.643844 0.84658,5.78494 2.68083,0.564384 5.07945,-4.232883 2.82193,-4.656171 3.6685,-0.423288 3.3863,-4.232883 0.1411,-7.619189 -2.11644,-2.963019 h -6.49042 l -5.78494,3.386307 -4.37398,3.809594 -0.56439,3.527403 z"
         id="503" class="tooth-area" (click)="toothClicked(503)" [class.selected]="isToothSelected(503)" [class.active]="isToothInProblem(503)"/>
      <path
         style="fill:#000000;fill-opacity:0"
         d="m 235.91268,46.985001 -2.11644,5.07946 1.26986,5.361651 5.07946,3.809595 2.11644,1.410961 4.37398,5.502748 4.51508,1.269865 1.97534,-2.398634 -0.84657,-6.349324 -0.56439,-2.116442 1.97535,-1.975345 -4.51508,-6.208228 -6.63152,-3.809595 h -4.93836 z"
         id="603" class="tooth-area" (click)="toothClicked(603)" [class.selected]="isToothSelected(603)" [class.active]="isToothInProblem(603)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 156.61667,29.065796 -4.79727,5.643844 v 5.784941 l 2.82192,0.846576 4.93837,1.975346 5.78494,-3.809595 0.28219,-3.24521 2.68083,-1.128769 -0.2822,-3.809595 -7.0548,-3.668499 z"
         id="502" class="tooth-area" (click)="toothClicked(502)" [class.selected]="isToothSelected(502)" [class.active]="isToothInProblem(502)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 180.17972,18.624685 -4.37398,3.950691 -0.1411,2.963018 6.34933,4.232883 4.09179,-0.141096 4.93836,-3.24521 0.70548,-3.809595 -5.64384,-5.07946 z"
         id="501" class="tooth-area" (click)="toothClicked(501)" [class.selected]="isToothSelected(501)" [class.active]="isToothInProblem(501)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 200.21537,18.765781 -4.65618,4.232883 -0.14109,3.527403 4.09178,0.846576 2.25754,2.116442 h 4.65617 l 2.96302,-1.975346 2.82192,-0.70548 -0.28219,-4.938364 -5.22055,-3.95069 z"
         id="601" class="tooth-area" (click)="toothClicked(601)" [class.selected]="isToothSelected(601)" [class.active]="isToothInProblem(601)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 223.77841,28.078124 -4.65617,3.527402 v 3.245211 l 1.97535,1.552057 1.12877,3.386306 2.96301,2.398634 4.65618,0.564384 2.82192,-1.975345 2.82192,0.564384 1.12877,-2.821922 -1.12877,-5.643844 -6.06713,-5.361652 z"
         id="602" class="tooth-area" (click)="toothClicked(602)" [class.selected]="isToothSelected(602)" [class.active]="isToothInProblem(602)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 114.58892,486.35616 6.08706,0.91306 5.32618,2.587 2.13047,5.02182 -0.60871,5.63053 -0.6087,5.93489 2.73918,8.06535 1.36958,13.69589 0.15218,22.36995 -3.80441,4.71747 -5.174,-0.76088 -8.21754,-9.43495 -3.1957,-9.58712 0.15217,-5.47835 -3.50006,-11.86977 0.15218,-20.84818 2.43482,-8.21753 z"
         id="808" class="tooth-area" (click)="toothClicked(808)" [class.selected]="isToothSelected(808)" [class.active]="isToothInProblem(808)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 258.70008,494.57369 0.30436,6.23924 1.36959,5.78271 -2.28265,7.15229 -1.21741,10.50018 -0.76089,5.93489 0.30436,21.91341 3.04353,3.19571 5.02182,0.76088 7.91318,-8.06535 3.34788,-10.19583 4.26095,-19.93512 -0.45653,-16.73942 -2.28265,-9.89147 -3.50006,-2.89136 -8.82624,0.76089 z"
         id="708" class="tooth-area" (click)="toothClicked(708)" [class.selected]="isToothSelected(708)" [class.active]="isToothInProblem(708)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 117.78463,566.40101 0.30435,6.08706 -3.95659,9.58712 -0.15218,10.348 4.5653,16.8916 4.26094,3.50006 h 5.93489 l 3.50006,-5.47836 -0.30436,-6.39141 1.36959,-10.65236 -0.15217,-13.54371 -0.91306,-7.1523 -3.19571,-6.23923 h -7.1523 z"
         id="807" class="tooth-area" (click)="toothClicked(807)" [class.selected]="isToothSelected(807)" [class.active]="isToothInProblem(807)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 256.56961,567.31407 -3.04353,16.28288 0.91306,11.86977 1.82612,14.3046 3.19571,3.1957 6.23923,0.76089 4.10877,-3.65224 v -5.78271 l 3.80441,-13.54371 0.15218,-7.761 -4.71747,-10.50018 -0.15218,-5.32618 -5.47835,-2.73918 -5.02183,0.60871 z"
         id="707" class="tooth-area" (click)="toothClicked(707)" [class.selected]="isToothSelected(707)" [class.active]="isToothInProblem(707)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 120.21945,619.05408 -0.15218,3.95659 -4.86964,8.36971 0.15217,8.52189 2.13047,13.54371 3.50006,2.89135 5.63053,0.30435 3.19571,-3.04353 v -3.50006 l 3.65224,-14.45677 v -10.95671 l -0.76088,-4.56529 -4.86965,-3.80441 -6.08706,0.15217 z"
         id="806" class="tooth-area" (click)="toothClicked(806)" [class.selected]="isToothSelected(806)" [class.active]="isToothInProblem(806)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 254.28697,620.57585 -1.21742,12.02194 0.60871,7.1523 4.10877,14.45677 2.73917,3.80441 5.32618,-0.15217 4.41312,-4.10877 0.15218,-3.95659 1.21741,-6.54359 0.30435,-11.41324 -5.32618,-8.82624 0.15218,-3.34788 -2.89135,-1.67394 -6.23924,0.15217 z"
         id="706" class="tooth-area" (click)="toothClicked(706)" [class.selected]="isToothSelected(706)" [class.active]="isToothInProblem(706)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 100.89303,706.25123 0.45653,8.06536 3.04353,14.00024 6.08706,11.56541 5.78271,3.80441 5.174,-0.76088 5.32618,-4.86965 2.43483,-6.08706 -0.15218,-9.43494 -2.89135,-4.10877 -7.00012,-4.86965 -4.10877,-7.00012 -2.13047,-8.52188 -0.76088,-9.43495 -1.67395,-3.1957 -4.10876,1.82611 -3.04353,9.58713 z"
         id="804" class="tooth-area" (click)="toothClicked(804)" [class.selected]="isToothSelected(804)" [class.active]="isToothInProblem(804)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 259.61314,721.16453 -1.52176,5.47835 0.91306,8.36971 3.95659,7.00012 5.47835,1.9783 h 4.5653 l 4.56529,-3.95659 4.5653,-8.52189 3.04353,-10.348 0.45653,-5.63053 -0.15218,-11.10889 -1.97829,-9.13059 -3.19571,-7.00012 -3.19571,-1.06524 -2.13047,1.67395 -0.45653,12.78282 -3.04353,9.1306 -5.93488,7.30447 -4.71747,1.82612 z"
         id="704" class="tooth-area" (click)="toothClicked(704)" [class.selected]="isToothSelected(704)" [class.active]="isToothInProblem(704)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 134.06751,750.99113 8.82624,0.15217 5.02183,3.65224 1.97829,4.71747 0.91306,5.32618 -3.19571,2.73918 -8.06535,0.15217 -6.39141,-6.23923 -1.06524,-4.5653 v -3.80441 z"
         id="803" class="tooth-area" (click)="toothClicked(803)" [class.selected]="isToothSelected(803)" [class.active]="isToothInProblem(803)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 238.91714,754.33901 -1.82612,4.26094 -0.15218,5.93489 2.89136,3.04353 8.82623,0.45653 5.63054,-7.00012 2.28264,-5.32618 -2.28264,-4.10877 -1.67395,-0.76088 -8.06535,-0.15218 z"
         id="703" class="tooth-area" (click)="toothClicked(703)" [class.selected]="isToothSelected(703)" [class.active]="isToothInProblem(703)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 151.41564,771.38278 v 4.41312 l 4.56529,6.23924 3.50006,2.28264 5.63053,-1.06523 3.80442,-3.65224 -0.60871,-3.65223 -2.13047,-1.36959 -0.45653,-2.28265 -3.19571,-3.80441 -6.08706,0.45653 -1.82612,1.97829 z"
         id="802" class="tooth-area" (click)="toothClicked(802)" [class.selected]="isToothSelected(802)" [class.active]="isToothInProblem(802)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 223.24295,769.40449 -3.04353,4.26094 v 2.43482 l -1.82611,0.30436 0.15217,3.80441 4.71747,3.50006 6.08707,-0.45653 5.47835,-5.32618 v -6.54359 l -3.80441,-0.76088 -3.04353,-2.28265 z"
         id="702" class="tooth-area" (click)="toothClicked(702)" [class.selected]="isToothSelected(702)" [class.active]="isToothInProblem(702)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 180.177,781.57861 7.45665,0.6087 4.41312,4.26095 -5.174,6.84794 h -5.93489 l -5.174,-4.26094 -0.15218,-5.02183 z"
         id="801" class="tooth-area" (click)="toothClicked(801)" [class.selected]="isToothSelected(801)" [class.active]="isToothInProblem(801)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 200.72083,782.03514 -5.02183,3.34788 v 4.41312 l 5.63054,3.50006 7.00012,-0.30435 3.95659,-5.02183 -1.21742,-4.56529 -2.43482,-0.15218 -5.02183,-2.43483 z"
         id="701" class="tooth-area" (click)="toothClicked(701)" [class.selected]="isToothSelected(701)" [class.active]="isToothInProblem(701)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 127.67096,208.8652 -8.95937,12.87909 -2.23984,14.55897 v 7.83945 l -3.91972,13.999 1.11992,15.11893 4.47968,5.03965 h 7.83945 l 6.71952,-8.39941 1.67988,-16.23885 6.15956,-27.43805 0.55996,-10.07929 -6.71952,-8.39941 z"
         id="507"
         class="tooth-area" (click)="toothClicked(507)" [class.selected]="isToothSelected(507)" [class.active]="isToothInProblem(507)"/>
   </g>
      </svg>
</div>

<div *ngIf="petService.pet_teeth.kitten"> 
   <svg
      version="1.1"
      id="svg1"
      width="254.08"
      height="485.12"
      viewBox="0 0 254.08 485.12"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:svg="http://www.w3.org/2000/svg"
      onclick="document.getElementById('tableToothProblem').scrollIntoView({ behavior: 'smooth' });"
      class="responsive-svg">
   <defs
      id="defs1" />
   <g
      id="g1">
      <image
         width="254.08"
         height="485.12"
         preserveAspectRatio="none"
         id="image3" xlink:href="assets/images/kitten-teeth.png" />
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 56.24707,154.61404 -5.4939,-2.35453 -2.616143,3.92421 -8.894885,23.54529 V 183.13 l 2.354528,2.09291 h 3.139372 l 6.278742,-6.54036 4.447443,-6.54035 3.139372,-7.58682 3.6626,-3.6626 -1.308072,-4.70906 -1.8313,-0.78484 z"
         id="507" class="tooth-area" (click)="toothClicked(507)" [class.selected]="isToothSelected(507)" [class.active]="isToothInProblem(507)" />
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 199.08847,152.25951 3.13937,5.4939 2.35453,5.4939 5.23228,17.26654 v 3.6626 l -3.6626,1.56969 -2.87775,-1.56969 -5.75552,-5.4939 -6.27874,-14.12717 -4.18583,-4.70906 2.09291,-4.18582 3.92422,-0.26162 2.35453,-3.13937 z"
         id="607" class="tooth-area" (click)="toothClicked(607)" [class.selected]="isToothSelected(607)" [class.active]="isToothInProblem(607)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 214.00048,207.19851 -4.70906,-0.26161 -0.52322,6.80197 10.46457,23.28367 3.13937,-0.26162 2.87775,-2.61614 -0.52322,-10.46457 -2.87776,-10.72619 0.26161,-7.06358 -2.87775,-1.30807 -2.87776,0.52323 z"
         id="608" class="tooth-area" (click)="toothClicked(608)" [class.selected]="isToothSelected(608)" [class.active]="isToothInProblem(608)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 34.533085,206.67528 -3.400986,-2.87776 -3.6626,3.92422 v 5.75551 l -2.616142,8.11004 0.261614,12.29588 2.877757,3.6626 3.139371,-1.04646 9.1565,-20.40592 1.569686,-4.44744 -2.354529,-4.97067 z"
         id="508" class="tooth-area" (click)="toothClicked(508)" [class.selected]="isToothSelected(508)" [class.active]="isToothInProblem(508)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 67.758098,87.902398 4.709057,-14.388785 6.540357,-6.540357 5.755515,-1.569686 3.139371,-6.801971 v -5.232286 l -4.709057,-4.447443 -7.586814,0.523229 -7.3252,6.540357 -4.447443,15.173628 v 14.6504 z"
         id="504" class="tooth-area" (click)="toothClicked(504)" [class.selected]="isToothSelected(504)" [class.active]="isToothInProblem(504)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 161.41601,53.369313 0.78484,7.848428 3.13937,3.924215 6.27875,2.354528 5.75551,5.232286 5.23229,15.958471 2.35453,-0.261615 1.8313,-6.278742 -1.04646,-11.772643 -1.8313,-9.418114 -8.11004,-10.9878 -10.20296,-0.784842 z"
         id="604" class="tooth-area" (click)="toothClicked(604)" [class.selected]="isToothSelected(604)" [class.active]="isToothInProblem(604)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 94.965983,37.410842 -2.092914,3.924214 1.046457,6.017129 2.092915,3.400985 5.232289,-0.523228 0.52322,-9.1565 -2.354524,-3.6626 z"
         id="503" class="tooth-area" (click)="toothClicked(503)" [class.selected]="isToothSelected(503)" [class.active]="isToothInProblem(503)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 107.26185,37.672456 4.44745,3.139372 0.52323,5.755514 -3.92422,2.354528 -3.40098,-0.523228 -1.30808,-3.924214 0.52323,-4.447443 z"
         id="502" class="tooth-area" (click)="toothClicked(502)" [class.selected]="isToothSelected(502)" [class.active]="isToothInProblem(502)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 121.65064,39.503756 1.04646,7.063586 -2.61615,1.308071 h -3.92421 l -1.8313,-6.017128 1.56969,-3.400986 z"
         id="501" class="tooth-area" (click)="toothClicked(501)" [class.selected]="isToothSelected(501)" [class.active]="isToothInProblem(501)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 127.40615,39.76537 -0.26161,7.063586 1.56969,1.569686 4.97067,-0.261615 1.56968,-2.877757 v -6.017128 l -2.61614,-1.308071 z"
         id="601" class="tooth-area" (click)="toothClicked(601)" [class.selected]="isToothSelected(601)" [class.active]="isToothInProblem(601)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 137.3475,40.026985 v 6.540357 l 2.09291,2.092914 4.44744,-0.523229 1.56969,-2.616142 0.26161,-6.017129 -2.35452,-1.569685 h -3.6626 z"
         id="602" class="tooth-area" (click)="toothClicked(602)" [class.selected]="isToothSelected(602)" [class.active]="isToothInProblem(602)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 148.59691,40.550213 v 8.371657 l 1.8313,1.308072 h 4.70906 l 2.09291,-5.4939 v -5.755514 l -2.87776,-2.354529 -2.87775,1.308072 z"
         id="603" class="tooth-area" (click)="toothClicked(603)" [class.selected]="isToothSelected(603)" [class.active]="isToothInProblem(603)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 66.973256,102.02957 -6.278743,1.8313 v 7.84843 l 2.092914,1.8313 3.6626,-1.30807 3.400986,-3.40099 0.784842,-3.13937 -1.046457,-3.40099 z"
         id="506" class="tooth-area" (click)="toothClicked(506)" [class.selected]="isToothSelected(506)" [class.active]="isToothInProblem(506)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 181.2987,102.5528 -2.35453,3.13937 2.35453,5.75551 4.18582,2.35453 h 2.61615 l 1.56968,-2.87776 -0.52323,-5.4939 -3.13937,-2.87775 z"
         id="606" class="tooth-area" (click)="toothClicked(606)" [class.selected]="isToothSelected(606)" [class.active]="isToothInProblem(606)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 35.579542,297.19382 -1.8313,9.1565 3.139371,12.8191 7.586815,13.60394 8.371656,0.78485 4.185829,-2.87776 0.261614,-6.80197 -4.185828,-8.63327 -2.616143,-6.54036 -3.6626,-9.94134 -5.232286,-3.40099 z"
         id="808" class="tooth-area" (click)="toothClicked(808)" [class.selected]="isToothSelected(808)" [class.active]="isToothInProblem(808)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 194.64102,336.69758 -4.70905,6.54035 -3.40099,17.52816 -0.26161,9.67973 4.70905,3.13937 6.54036,-2.61614 4.44744,-9.41812 3.40099,-6.01712 0.78484,-15.69686 -6.27874,-3.13937 z"
         id="707" class="tooth-area" (click)="toothClicked(707)" [class.selected]="isToothSelected(707)" [class.active]="isToothInProblem(707)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 199.87331,305.56548 -0.26161,5.75551 -6.01713,12.29587 v 7.58682 l 4.44744,2.87775 7.06359,-0.78484 4.44744,-5.75551 6.27874,-14.12717 0.52323,-10.72619 -4.18583,-7.58681 -4.18583,0.26161 -5.75551,6.27874 z"
         id="708" class="tooth-area" (click)="toothClicked(708)" [class.selected]="isToothSelected(708)" [class.active]="isToothInProblem(708)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 87.640784,425.90805 -5.232286,6.01713 -1.8313,1.04645 -5.4939,0.26162 -8.894885,-3.6626 -3.400986,1.04645 3.139371,5.23229 12.295872,8.89489 9.156499,1.56968 7.063586,-3.40098 3.139371,-6.54036 -0.261614,-6.80197 -4.709057,-3.6626 z"
         id="804" class="tooth-area" (click)="toothClicked(804)" [class.selected]="isToothSelected(804)" [class.active]="isToothInProblem(804)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 151.9979,429.83226 0.78484,7.3252 3.13937,5.75552 6.54036,2.87775 9.1565,-0.52323 7.58681,-5.4939 8.11004,-8.37165 -4.70905,-1.8313 -7.58682,3.6626 -6.80197,-0.78485 -5.75551,-6.01712 -7.06359,0.26161 z"
         id="704" class="tooth-area" (click)="toothClicked(704)" [class.selected]="isToothSelected(704)" [class.active]="isToothInProblem(704)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 99.936655,433.49486 5.232285,0.78484 2.09291,4.44745 -1.04645,5.75551 -3.6626,1.04646 -4.185831,-2.61614 -1.046457,-4.44745 z"
         id="803" class="tooth-area" (click)="toothClicked(803)" [class.selected]="isToothSelected(803)" [class.active]="isToothInProblem(803)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 108.83154,434.80293 6.01713,0.52323 1.30807,3.40099 -1.30807,4.70905 -5.75552,0.26162 -1.30807,-1.56969 0.26162,-4.44744 z"
         id="802" class="tooth-area" (click)="toothClicked(802)" [class.selected]="isToothSelected(802)" [class.active]="isToothInProblem(802)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 116.94158,436.37262 3.13937,-2.09292 3.92422,2.09292 v 6.80197 l -2.09292,0.78484 -4.97067,-1.8313 z"
         id="801" class="tooth-area" (click)="toothClicked(801)" [class.selected]="isToothSelected(801)" [class.active]="isToothInProblem(801)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 128.191,434.2797 -2.35453,2.87776 0.78484,4.44744 2.09292,2.61615 2.61614,-0.52323 1.56968,-1.8313 V 436.111 l -2.09291,-2.35452 z"
         id="701" class="tooth-area" (click)="toothClicked(701)" [class.selected]="isToothSelected(701)" [class.active]="isToothInProblem(701)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 135.5162,434.54132 4.97067,0.52323 1.8313,7.3252 -2.09292,1.56968 -4.97067,-0.52323 -1.04645,-4.18582 z"
         id="702" class="tooth-area" (click)="toothClicked(702)" [class.selected]="isToothSelected(702)" [class.active]="isToothInProblem(702)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 143.88785,435.58778 0.26162,7.3252 1.8313,2.09291 h 3.13937 l 3.40098,-3.6626 v -4.18583 l -2.61614,-3.6626 h -4.18583 z"
         id="703" class="tooth-area" (click)="toothClicked(703)" [class.selected]="isToothSelected(703)" [class.active]="isToothInProblem(703)"/>
   </g>
   </svg> 
</div>

<div *ngIf="petService.pet_teeth.cat"> 
   <svg
      version="1.1"
      id="svg1"
      width="400"
      height="804"
      viewBox="0 0 400 804"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:svg="http://www.w3.org/2000/svg"
      onclick="document.getElementById('tableToothProblem').scrollIntoView({ behavior: 'smooth' });"
      class="responsive-svg">
   <defs
      id="defs1" />
   <g
      id="g1">
      <image
         width="400"
         height="804"
         preserveAspectRatio="none"
         id="image4" xlink:href="assets/images/cat-teeth.png" />
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 150.56985,62.965575 8.55606,1.043718 5.38395,8.973265 -3.5893,4.785742 -0.89733,8.075939 -5.98217,2.991088 -5.08486,-1.794653 -1.79465,-14.058116 z"
         id="103" class="tooth-area" (click)="toothClicked(103)" [class.selected]="isToothSelected(103)" [class.active]="isToothInProblem(103)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 171.68848,81.058497 4.48663,-0.897326 2.09376,-8.674157 2.69198,-6.281286 -2.09376,-2.691979 -13.75901,0.897326 v 6.281286 l 2.39287,4.785741 0.89733,5.982177 z"
         id="102" class="tooth-area" (click)="toothClicked(102)" [class.selected]="isToothSelected(102)" [class.active]="isToothInProblem(102)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 181.55907,63.111966 0.89733,6.281286 5.38395,9.272374 h 3.58931 l 2.69198,-6.580394 4.18752,-8.075939 -2.69198,-2.69198 z"
         id="101" class="tooth-area" (click)="toothClicked(101)" [class.selected]="isToothSelected(101)" [class.active]="isToothInProblem(101)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 199.20649,62.21464 v 3.589306 l 3.2902,4.785742 2.09376,6.580394 2.99109,1.794653 2.69198,-1.196435 1.79465,-6.281286 2.99109,-3.290197 v -6.281286 l -6.28129,0.299109 z"
         id="201" class="tooth-area" (click)="toothClicked(201)" [class.selected]="isToothSelected(201)" [class.active]="isToothInProblem(201)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 215.65748,63.710184 1.49554,4.486633 2.09376,4.187524 1.19644,6.879503 3.58931,2.392871 h 3.88841 l 2.39287,-4.785742 -0.29911,-3.589306 2.39287,-5.08485 v -6.281286 z"
         id="202" class="tooth-area" (click)="toothClicked(202)" [class.selected]="isToothSelected(202)" [class.active]="isToothInProblem(202)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 232.70668,72.384341 6.5804,-8.375048 6.28128,-0.598218 4.18753,5.084851 -0.89733,16.151877 -3.88842,3.589306 -6.28128,-0.897326 -1.79465,-8.973266 z"
         id="203" class="tooth-area" (click)="toothClicked(203)" [class.selected]="isToothSelected(203)" [class.active]="isToothInProblem(203)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 116.05423,112.76403 -7.47772,15.55366 -3.2902,17.64743 -0.29911,11.06702 2.39288,2.69198 4.18752,-2.09376 8.37505,-13.16079 8.37504,-8.67415 h 5.08486 l 7.47772,-5.08485 4.18752,-9.57149 -1.79465,-8.07594 -7.77683,-6.58039 -11.66525,0.29911 z"
         id="104" class="tooth-area" (click)="toothClicked(104)" [class.selected]="isToothSelected(104)" [class.active]="isToothInProblem(104)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 252.14876,122.33552 5.68306,9.57148 6.87951,4.48663 h 5.08485 l 8.67416,8.07594 6.58039,12.26346 3.2902,2.39288 3.5893,-0.59822 0.89733,-2.39287 v -13.4599 l -3.88842,-15.25455 -7.17861,-14.05812 -8.67415,-6.8795 h -11.36614 l -8.07594,6.8795 z"
         id="204" class="tooth-area" (click)="toothClicked(204)" [class.selected]="isToothSelected(204)" [class.active]="isToothInProblem(204)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 104.9872,171.09026 -5.683063,6.28129 0.299108,8.37504 4.486635,2.99109 11.66524,-0.29911 4.78574,-7.17861 -0.2991,-6.58039 -6.87951,-3.88842 z"
         id="106" class="tooth-area" (click)="toothClicked(106)" [class.selected]="isToothSelected(106)" [class.active]="isToothInProblem(106)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 276.97479,179.46531 4.78574,7.17861 2.99109,2.09376 10.1697,-0.59822 4.18753,-3.29019 -0.29911,-8.37505 -4.18753,-5.08485 -9.27237,-0.29911 -7.77683,3.88841 z"
         id="206" class="tooth-area" (click)="toothClicked(206)" [class.selected]="isToothSelected(206)" [class.active]="isToothInProblem(206)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 87.040674,220.44322 -7.178612,17.0492 -4.187524,15.85277 0.897326,3.88842 6.281286,4.78574 4.785742,0.89733 2.991088,-1.49555 4.486633,-6.28128 3.290197,-2.09377 12.56257,-16.75009 0.29911,-25.72336 -4.78574,-4.48664 -8.07594,-1.49554 -7.178612,5.38396 z"
         id="107" class="tooth-area" (click)="toothClicked(107)" [class.selected]="isToothSelected(107)" [class.active]="isToothInProblem(107)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 287.14449,210.57263 0.29911,25.42425 2.09376,4.78574 15.25455,16.15188 2.69198,4.48663 4.78574,2.09376 9.8706,-6.58039 -0.29911,-7.47772 -2.99109,-11.66525 -7.47772,-15.25455 -3.2902,-11.96435 -5.98218,-4.78574 -5.98217,-1.19644 z"
         id="207" class="tooth-area" (click)="toothClicked(207)" [class.selected]="isToothSelected(207)" [class.active]="isToothInProblem(207)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 65.803946,276.67568 -5.08485,12.86168 -11.964354,38.88415 v 7.47772 l 3.290197,3.2902 6.580395,-0.29911 16.151877,-17.0492 6.281286,-9.87059 5.383959,-15.85277 6.580395,-9.8706 5.982177,-2.69197 3.290202,-4.78575 -2.09377,-5.98217 -5.383956,-2.09376 -8.973265,0.2991 -7.77683,-7.17861 -6.281286,-0.29911 -4.785742,7.17862 z"
         id="108" class="tooth-area" (click)="toothClicked(108)" [class.selected]="isToothSelected(108)" [class.active]="isToothInProblem(108)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 334.7028,282.05964 15.25455,47.2592 v 6.28128 l -3.88842,3.58931 -5.68306,-0.29911 -16.15188,-15.55366 -7.17861,-12.26346 -6.87951,-18.84386 -5.38396,-6.8795 -7.17861,-3.2902 -0.89733,-6.58039 5.98218,-4.48664 h 8.97327 l 9.27237,-6.8795 5.68307,-0.29911 3.88841,5.08485 1.49555,2.69198 v 4.78574 z"
         id="208" class="tooth-area" (click)="toothClicked(208)" [class.selected]="isToothSelected(208)" [class.active]="isToothInProblem(208)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 50.549395,346.66715 v 5.38396 l 5.683068,5.08485 5.683068,2.99109 10.169701,-2.69198 0.897326,-5.38396 -3.589306,-7.47772 -6.580394,-2.39287 -3.589307,1.79465 z"
         id="109" class="tooth-area" (click)="toothClicked(109)" [class.selected]="isToothSelected(109)" [class.active]="isToothInProblem(109)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 328.42151,344.8725 -3.5893,8.37505 0.59821,3.88841 7.47772,2.39287 4.18753,0.29911 5.98218,-3.2902 4.78574,-5.08485 v -4.18752 l -7.77683,-2.69198 -6.87951,-2.39287 z"
         id="209" class="tooth-area" (click)="toothClicked(209)" [class.selected]="isToothSelected(209)" [class.active]="isToothInProblem(209)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 52.344048,479.17237 13.759007,19.14297 6.580394,3.5893 9.571483,-1.49554 4.785742,-4.18753 0.897327,-9.87059 -6.879504,-13.4599 -8.075939,-11.36613 -3.888415,-12.26346 -11.366136,-11.36614 -6.580394,0.29911 -6.281286,10.1697 -0.598218,9.87059 2.991089,10.1697 z"
         id="409" class="tooth-area" (click)="toothClicked(409)" [class.selected]="isToothSelected(409)" [class.active]="isToothInProblem(409)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 310.17587,481.86435 -1.49554,9.87059 2.39287,6.28129 4.78574,2.99109 8.67416,1.19643 6.58039,-4.18752 13.4599,-19.14297 7.17861,-17.64742 0.89733,-12.56257 -6.5804,-10.1697 -7.17861,-0.59822 -11.36613,9.87059 -1.79466,6.5804 -0.59822,5.38396 -5.68306,8.67415 z"
         id="309" class="tooth-area" (click)="toothClicked(309)" [class.selected]="isToothSelected(309)" [class.active]="isToothInProblem(309)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 92.723742,518.35563 4.486633,15.55366 5.084855,14.05811 -1.19644,8.97327 -5.683068,7.77683 -9.272375,-0.89733 -9.870591,-10.76791 -0.598218,-4.48664 -7.477721,-11.06702 -2.991089,-12.56258 v -11.66524 l 8.075939,-5.38396 10.46881,-0.59822 6.879503,6.28129 z"
         id="408" class="tooth-area" (click)="toothClicked(408)" [class.selected]="isToothSelected(408)" [class.active]="isToothInProblem(408)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 304.79191,514.16811 -4.18752,15.85276 -5.68307,17.04921 -0.29911,8.37505 4.78574,7.77683 6.5804,1.49554 8.97326,-3.58931 6.5804,-13.16079 7.47772,-12.86168 2.99109,-14.05811 -1.49555,-9.27238 -8.97326,-4.78574 h -8.37505 z"
         id="308" class="tooth-area" (click)="toothClicked(308)" [class.selected]="isToothSelected(308)" [class.active]="isToothInProblem(308)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 278.17123,580.86938 -9.27238,24.52692 1.19644,5.98218 4.48663,4.48663 8.97327,0.29911 7.47772,-6.28128 3.5893,-4.78575 9.27238,-20.93762 v -7.77683 l -7.47772,-6.28128 -8.07594,-0.59822 z"
         id="307" class="tooth-area" (click)="toothClicked(307)" [class.selected]="isToothSelected(307)" [class.active]="isToothInProblem(307)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 107.67918,570.10146 10.16971,10.46881 8.97326,20.63851 1.19644,7.77683 -4.48664,5.98218 -10.1697,1.19643 -8.07594,-6.8795 -7.477718,-14.95544 -5.982176,-11.06703 1.196435,-7.47772 5.683068,-4.78574 z"
         id="407" class="tooth-area" (click)="toothClicked(407)" [class.selected]="isToothSelected(407)" [class.active]="isToothInProblem(407)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 133.10344,696.92361 -7.17862,1.19644 -12.56257,-0.89733 -2.39287,4.18752 5.68307,9.27238 v 0 l 13.16079,9.57148 12.86168,4.78574 7.77683,-2.39287 7.77683,-7.77683 1.49554,-7.77683 -2.69198,-11.96435 -5.38396,-5.68307 -7.47772,-0.89733 -7.47772,7.77683 z"
         id="404" class="tooth-area" (click)="toothClicked(404)" [class.selected]="isToothSelected(404)" [class.active]="isToothInProblem(404)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 240.78262,713.3746 4.48663,6.8795 9.57149,4.48663 9.87059,-1.49554 18.54475,-13.4599 4.48663,-8.07594 -1.79465,-4.18752 -5.68307,-1.19644 -9.57148,2.39287 -9.8706,-2.69198 -4.18752,-6.8795 h -8.97327 l -6.8795,8.37505 -1.49554,9.27237 z"
         id="304" class="tooth-area" (click)="toothClicked(304)" [class.selected]="isToothSelected(304)" [class.active]="isToothInProblem(304)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 159.42501,722.64697 0.29911,8.37505 2.99109,3.5893 h 4.18753 l 3.5893,-4.18752 1.79465,-5.68307 -4.18752,-7.17861 -5.98218,0.59822 z"
         id="403" class="tooth-area" (click)="toothClicked(403)" [class.selected]="isToothSelected(403)" [class.active]="isToothInProblem(403)"/>
      <path
         style="display:none;fill:#1a1a1a;fill-opacity:0"
         d="m 175.57689,720.55321 5.08485,1.79465 3.2902,6.5804 1.19644,4.48663 -3.88842,2.39287 -8.37505,-1.49554 -0.89732,-2.99109 z"
         id="402" class="tooth-area" (click)="toothClicked(402)" [class.selected]="isToothSelected(402)" [class.active]="isToothInProblem(402)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 190.53233,721.74964 -4.48663,7.17862 v 4.18752 l 3.2902,2.69198 7.77683,-0.59822 v -6.58039 l -2.69198,-5.38396 z"
         id="401" class="tooth-area" (click)="toothClicked(401)" [class.selected]="isToothSelected(401)" [class.active]="isToothInProblem(401)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 201.30025,733.714 3.88842,1.79465 7.47772,-0.59822 0.29911,-7.17861 -4.48663,-5.98218 -3.2902,0.89733 -1.49555,5.68307 z"
         id="301" class="tooth-area" (click)="toothClicked(301)" [class.selected]="isToothSelected(301)" [class.active]="isToothInProblem(301)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 215.35837,728.33004 -1.19644,4.48663 2.99109,2.09376 8.37505,0.29911 0.89733,-6.58039 -3.2902,-8.07594 -5.08485,1.49554 z"
         id="302" class="tooth-area" (click)="toothClicked(302)" [class.selected]="isToothSelected(302)" [class.active]="isToothInProblem(302)"/>
      <path
         style="fill:#1a1a1a;fill-opacity:0"
         d="m 230.31381,718.45945 6.28129,0.89732 2.09376,4.48664 -0.29911,7.77683 -2.69198,2.69198 h -5.38396 l -2.39287,-3.88842 -0.89733,-6.58039 z"
         id="303" class="tooth-area" (click)="toothClicked(303)" [class.selected]="isToothSelected(303)" [class.active]="isToothInProblem(303)"/>
   </g>
   </svg>
</div>


<style>
   .tooth-area.selected {
        stroke: rgba(0, 150, 255, 0.7);
        stroke-width: 4px; 
    }

    .tooth-area.active {
        stroke: rgb(0, 71, 171);
        stroke-width: 4px; 
    }

    .tooth-area:hover {
       stroke: rgba(0, 150, 255, 0.7);
       stroke-width: 3px; 
    }

    .responsive-svg {
      width: 100%;
      height: auto; /* Scales height proportionally to the width. Fills container width. */
      /* If you want the SVG to fill a container with a specific height, use height: 100%;
         and manage aspect ratio with preserveAspectRatio (see explanation below) */
      display: block; /* Removes extra space below the SVG if its container is inline */
   }
</style>